import { defineMessages } from 'react-intl-next';

export const messages: {
    repositoryLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	repositoryLabel: {
		id: 'dynamic-cards-search-page.search-result.repository-label',
		defaultMessage: 'Repository',
		description: 'Repository metadata label shown as part of the metadata below the repository title in the search results, for example "Repository • Updated 2 hours ago"',
	},
});
